import React from 'react'
import { Link } from 'gatsby'
import Img from '@/lib/Img'
import NoImg from '@/lib/NoImg'
import PostMetadata from './PostMetadata'

const ArticlePreview = ({ post }) => {
	const url = '/blog/' + post.metaInfo?.slug.current

	return (
		<article className="anim-fadein <md:full-width">
			<Link className="group grid md:grid-cols-2 items-center" to={url}>
				<figure className="self-stretch overflow-hidden text-center">
					{!!post.featuredImage
						? <Img
							className="aspect-[2] group-hover:scale-105 group-hover:brightness-110 transition-all"
							objectFit="cover"
							image={post.featuredImage}
							alt={post.title}
						/>
						: <NoImg />
					}
				</figure>

				<div className="p-4 md:-order-1 richtext">
					<h2 className="h1">{post.title}</h2>
					<p>{post.excerpt || post.metaInfo?.description}</p>
					<PostMetadata {...post} />
				</div>
			</Link>
		</article>
	)
}

export default ArticlePreview
